import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from '../../data/model/user';
import { PasswordResetApiService } from '../../shared/api/services/password-reset-api.service';
import { SharedModule } from '../../shared/shared.module';

const Validate: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const pass1 = control.get('new_password1')?.value;
  const pass2 = control.get('new_password2')?.value;
  const username = control.get('username')?.value;


  if (!pass1 || !pass2 || !username) {
    return null;
  }
  var num_equals=0
  for(var i=0; i <= String(username).length; i++){
    const letters=username.charAt(i)+username.charAt(i+1)+username.charAt(i+2)+username.charAt(i+3)
    if(pass1.includes(letters)){
      num_equals=num_equals+1
    }
  }
  if(String(username).length- num_equals<String(username).length/2){
    return { 'username': true };
  }
  return pass1 === pass2 ? null : { 'app-password-reset-dialog': true };

};

@Component({
  standalone: true,
  imports:[SharedModule],
  selector: 'app-password-reset-dialog',
  templateUrl: './password-reset-dialog.component.html',
  styleUrls: ['./password-reset-dialog.component.scss']
})
export class PasswordResetDialogComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private apiService: PasswordResetApiService,
    public dialogRef: MatDialogRef<PasswordResetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: User }
  ) {}

  ngOnInit(): void {
  }

  static error: ValidationErrors;
  showPassword = false;
  showConfirmPassword = false;
  oldPassword = false

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  toggleOldPassword() {
    this.oldPassword = !this.oldPassword;
  }


  entityFormGroup: FormGroup= this.formBuilder.group({
    username:this.data.user.username,
    old_password:[null, [Validators.required, Validators.maxLength(255), Validators.minLength(8)]],
    new_password1: [null, [Validators.required, Validators.maxLength(255), Validators.minLength(8)]],
    new_password2: [null, [Validators.required, Validators.maxLength(255), Validators.minLength(8)]],
  },{ validator: Validate });

  saveClicked() {
    this.entityFormGroup.markAllAsTouched();

    if (this.entityFormGroup.valid){
      this.apiService.create(this.entityFormGroup.value).subscribe(
        (response) => {
          console.log(response);
          this.dialogRef.close();
        },
        (error) => {
          console.log(error);
        }
      )
    } else {
      Object.keys(this.entityFormGroup.controls).forEach(key => {
        const controlErrors = this.entityFormGroup.get(key)?.errors;
        console.log(key, controlErrors); // Logs the control name and its errors
      });
    }
  }


}
